import { useState, useCallback, useEffect } from "react";
import { useApi } from "providers/ApiProvider";
import { getOptions } from "hooks/useFormSelect";
import { DropdownList as _DropdownList } from "components/DropdownList";
import { styled } from "@mui/material";

export const DropdownList = styled(_DropdownList)(
  ({ theme }) => `
  height: 34px;
  
  input {
    padding-left: 20px !important;
    font-size: 14px !important;
    &::placeholder {
      color: ${theme.palette.bluegrey["600"]};
      opacity: 1;
    }
  }
  .MuiOutlinedInput-root {
    border-radius: 4px !important;
    font-size: 14px !important;
  }
  fieldset {
    border-color: ${theme.palette.layout.line};
  }
`
);

type CounselorSelectProps = {
  value: any;
  onChange: (value: any) => void;
};

export function CounselorSelect({ value, onChange }: CounselorSelectProps) {
  const { userApi } = useApi();
  const [counselors, setCounselors] = useState([]);

  const loadCounselors = useCallback(async () => {
    const res = await userApi.getDuty("상담사");
    const payload = await res.data;
    payload.data && setCounselors(payload.data);
  }, [userApi]);

  useEffect(() => {
    loadCounselors();
  }, [loadCounselors]);

  return (
    <>
      <DropdownList
        options={getOptions(counselors ?? []).map((item: any) => {
          item.label = item.name;
          return item;
        })}
        value={counselors.find((f: any) => f.id === value?.id)}
        onChange={(v) => {
          onChange(v ?? null);
        }}
        placeholder="상담사를 선택하세요."
      />
    </>
  );
}
